import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Container,
	Paper,
	Typography,
} from "@mui/material"
import { styled } from "@mui/material/styles"
import { FC, useState } from "react"
import { useTranslation } from "react-i18next"
import { handleLinkClick } from "../../store/actions/template"
import faqs, { FAQSection } from "../../store/data/faq"

const CustomAccordion = styled(Accordion)(() => ({
	margin: "16px 0",
	"&.Mui-expanded": {
		backgroundColor: "#FDF0CE",
		fontWeight: "bold",
	},
}))

const CustomAccordionSummary = styled(AccordionSummary)(() => ({
	"&.Mui-expanded": {
		backgroundColor: "#FDF0CE",
	},
}))

const FAQ: FC = () => {
	const { t } = useTranslation()
	const [searchTerm, setSearchTerm] = useState<string>("")

	const filteredFaqs: FAQSection[] = faqs.map((section: FAQSection) => ({
		...section,
		items: section.items.filter((faq) =>
			t(`${section.section}.items.${faq.answer}`, { ns: "faq" })
				.toLowerCase()
				.includes(searchTerm.toLowerCase())
		),
	}))

	const parseAnswer = (answer: string) => {
		return answer
			.split(/(<a\s+data-action=['"](.*?)['"]>.*?<\/a>)/g)
			.map((part, index) => {
				if (part.startsWith("<a data-action=")) {
					const actionMatch = part.match(/data-action=['"](.*?)['"]/)
					if (actionMatch) {
						const action = actionMatch[1]
						console.log(part)
						return (
							<a
								key={index}
								href="#"
								onClick={(e) => {
									e.preventDefault()
									handleLinkClick(e, action, "xls")
								}}
							>
								{" "}
								{part
									.replace(/<a\s+data-action=['"](.*?)['"]>/g, "")
									.replace("</a>", "")}{" "}
							</a>
						)
					}
				}
				return part
			})
	}

	return (
		<Container
			component={Paper}
			elevation={3}
			style={{ padding: "16px", maxWidth: "800px" }}
		>
			<Typography variant="h4" gutterBottom>
				{t("title", { ns: "faq" })}
			</Typography>
			{/*<TextField
				variant="outlined"
				fullWidth
				label={t("search.label", { ns: "faq" })}
				value={searchTerm}
				onChange={(e) => setSearchTerm(e.target.value)}
				margin="normal"
			/>*/}
			{filteredFaqs.map((section, sectionIndex) => (
				<div key={`section_${sectionIndex}`}>
					<Typography variant="h5" gutterBottom>
						{t(`${section.section}.title`, { ns: "faq" })}
					</Typography>
					{section.items.map((faq, faqIndex) => (
						<CustomAccordion key={`faq_${faqIndex}`}>
							<CustomAccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls={`panel${sectionIndex}-content`}
								id={`panel${sectionIndex}-header`}
							>
								<Typography>
									{t(`${section.section}.items.${faq.question}`, { ns: "faq" })}
								</Typography>
							</CustomAccordionSummary>
							<AccordionDetails>
								<Typography component="div">
									{parseAnswer(
										t(`${section.section}.items.${faq.answer}`, { ns: "faq" })
									)}
								</Typography>
							</AccordionDetails>
						</CustomAccordion>
					))}
				</div>
			))}
		</Container>
	)
}

export default FAQ
